import { timeOfBooking } from "../../dependencies/utils";

// `timeOfBooking` is a host-injected formatter and a pure function of its
// argument, so results can be cached. Availability slots draw on a small set of
// distinct times, but there are tens of thousands of slots across a city list,
// so an uncached check runs one host date parse per slot on every recomputation.
const validityByTime = new Map<string, boolean>();

// Distinct booking times number in the dozens. The bound only guards against a
// host returning unexpected values; clearing wholesale is fine because
// repopulating is cheap.
const MAX_CACHED_TIMES = 512;

/**
 * Whether a slot time is one the host can render as a booking time. Equivalent
 * to `timeOfBooking(time) !== false`, memoised.
 */
export default function isBookingTimeValid(time: string): boolean {
  const cached = validityByTime.get(time);

  if (cached !== undefined) {
    return cached;
  }

  const valid = timeOfBooking(time) !== false;

  if (validityByTime.size >= MAX_CACHED_TIMES) {
    validityByTime.clear();
  }

  validityByTime.set(time, valid);

  return valid;
}
